<template>
  <v-container
    fluid
    :class="{
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode,
      isBlocked: !editMode,
    }"
  >
    <loading v-if="!financeData && !financeData.length" />

    <v-layout row wrap v-else>
      <v-flex :class="{ xs12: !editMode, xs9: editMode, isBlocked: !editMode }">
        <v-layout row wrap v-if="!publicMode">
          <v-flex xs4>
            <v-btn
              @click="downloadZip"
              color="primary"
              :loading="isDownloadZip"
              class="ma-0 mb-4 px-0"
              outlined
            >
              <v-icon color="primary" size="20px">archive</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs8 v-if="zipErrors">{{ zipErrors }}</v-flex>
        </v-layout>
        <v-form ref="form" v-model="valid">
          <v-layout row wrap finance>
            <v-flex xs12>
              <table class="finance__table">
                <tr>
                  <td colspan="5">
                    <h1>Форма 1</h1>
                  </td>
                </tr>

                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="`one_${idx}`"
                    :class="`text-${title.align}`"
                  >
                    {{ title.name }}
                  </th>
                </tr>

                <!-- **************************************************************************** -->
                <tr class="finance__header-small">
                  <th colspan="5">
                    <h1>Актив</h1>
                  </th>
                </tr>

                <!-- **************************************************************************** -->
                <tr class="finance__header-small">
                  <th colspan="5">I. ВНЕОБОРОТНЫЕ АКТИВЫ</th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formOne.active.outOfStock"
                  :key="'outOfStock' + idx"
                  class="finance__row"
                >
                  <td>{{ getFinanceNames(item.id) }}</td>
                  <td class="text-center">
                    <em>{{ item.id }}</em>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value1"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value1 = Number(item.value1)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value2"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value2 = Number(item.value2)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value3"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value3 = Number(item.value3)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Итого по разделу I</td>
                  <td class="text-right">
                    {{ getTotalFormOneActiveOutOfStockValue1 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOneActiveOutOfStockValue2 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOneActiveOutOfStockValue3 | formatNumber }}
                  </td>
                </tr>

                <tr class="finance__divider">
                  <td colspan="5"></td>
                </tr>
                <!-- **************************************************************************** -->

                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="`one_${idx}`"
                    :class="`text-${title.align}`"
                  >
                    {{ title.name }}
                  </th>
                </tr>

                <tr class="finance__header-small">
                  <th colspan="5">II. ОБОРОТНЫЕ АКТИВЫ</th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formOne.active.inStock"
                  :key="'inStock' + idx"
                  class="finance__row"
                >
                  <td>{{ getFinanceNames(item.id) }}</td>
                  <td class="text-center">
                    <em>{{ item.id }}</em>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value1"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value1 = Number(item.value1)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value2"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value2 = Number(item.value2)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value3"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value3 = Number(item.value3)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Итого по разделу II</td>
                  <td class="text-right">
                    {{
                      getTotalFormOneActiveInStockValue1.toLocaleString("ru")
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      getTotalFormOneActiveInStockValue2.toLocaleString("ru")
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      getTotalFormOneActiveInStockValue3.toLocaleString("ru")
                    }}
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Баланс</td>
                  <td class="text-right">
                    {{
                      (getTotalFormOneActiveOutOfStockValue1 +
                        getTotalFormOneActiveInStockValue1)
                        | formatNumber
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (getTotalFormOneActiveOutOfStockValue2 +
                        getTotalFormOneActiveInStockValue2)
                        | formatNumber
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (getTotalFormOneActiveOutOfStockValue3 +
                        getTotalFormOneActiveInStockValue3)
                        | formatNumber
                    }}
                  </td>
                </tr>

                <tr class="finance__divider">
                  <td colspan="5"></td>
                </tr>

                <!-- **************************************************************************** -->
                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="`one_${idx}`"
                    :class="`text-${title.align}`"
                  >
                    {{ title.name }}
                  </th>
                </tr>

                <tr class="finance__header-small">
                  <th colspan="5">
                    <h1>Пассив</h1>
                  </th>
                </tr>

                <!-- **************************************************************************** -->
                <tr class="finance__header-small">
                  <th colspan="5">III. КАПИТАЛ И РЕЗЕРВЫ</th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formOne.passive.capital"
                  :key="'capital' + idx"
                  class="finance__row"
                >
                  <td>{{ getFinanceNames(item.id) }}</td>
                  <td class="text-center">
                    <em>{{ item.id }}</em>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value1"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value1 = Number(item.value1)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value2"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value2 = Number(item.value2)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value3"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value3 = Number(item.value3)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Итого по разделу III</td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveCapitalValue1 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveCapitalValue2 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveCapitalValue3 | formatNumber }}
                  </td>
                </tr>

                <tr class="finance__divider">
                  <td colspan="5"></td>
                </tr>
                <!-- **************************************************************************** -->
                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="`one_${idx}`"
                    :class="`text-${title.align}`"
                  >
                    {{ title.name }}
                  </th>
                </tr>

                <tr class="finance__header-small">
                  <th colspan="5">IV. ДОЛГОСРОЧНЫЕ ОБЯЗАТЕЛЬСТВА</th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formOne.passive.longNeeds"
                  :key="'longNeeds' + idx"
                  class="finance__row"
                >
                  <td>{{ getFinanceNames(item.id) }}</td>
                  <td class="text-center">
                    <em>{{ item.id }}</em>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value1"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value1 = Number(item.value1)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value2"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value2 = Number(item.value2)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value3"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value3 = Number(item.value3)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Итого по разделу IV</td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveLongNeedsValue1 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveLongNeedsValue2 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveLongNeedsValue3 | formatNumber }}
                  </td>
                </tr>

                <tr class="finance__divider">
                  <td colspan="5"></td>
                </tr>

                <!-- **************************************************************************** -->
                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="`one_${idx}`"
                    :class="`text-${title.align}`"
                  >
                    {{ title.name }}
                  </th>
                </tr>
                <tr class="finance__header-small">
                  <th colspan="5">V. КРАТКОСРОЧНЫЕ ОБЯЗАТЕЛЬСТВА</th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formOne.passive.shortNeeds"
                  :key="'shortNeeds' + idx"
                  class="finance__row"
                >
                  <td>{{ getFinanceNames(item.id) }}</td>
                  <td class="text-center">
                    <em>{{ item.id }}</em>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value1"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value1 = Number(item.value1)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value2"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value2 = Number(item.value2)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="item.value3"
                      type="number"
                      placeholder="0"
                      v-on:blur="item.value3 = Number(item.value3)"
                      :disabled="packageMode && !editMode"
                    ></v-text-field>
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Итого по разделу V</td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveShortNeedsValue1 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveShortNeedsValue2 | formatNumber }}
                  </td>
                  <td class="text-right">
                    {{ getTotalFormOnePassiveShortNeedsValue3 | formatNumber }}
                  </td>
                </tr>

                <tr class="finance__total">
                  <td colspan="2">Баланс</td>
                  <td class="text-right">
                    {{
                      (
                        getTotalFormOnePassiveCapitalValue1 +
                        getTotalFormOnePassiveLongNeedsValue1 +
                        getTotalFormOnePassiveShortNeedsValue1
                      ).toLocaleString("ru")
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (
                        getTotalFormOnePassiveCapitalValue2 +
                        getTotalFormOnePassiveLongNeedsValue2 +
                        getTotalFormOnePassiveShortNeedsValue2
                      ).toLocaleString("ru")
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      (
                        getTotalFormOnePassiveCapitalValue3 +
                        getTotalFormOnePassiveLongNeedsValue3 +
                        getTotalFormOnePassiveShortNeedsValue3
                      ).toLocaleString("ru")
                    }}
                  </td>
                </tr>

                <tr>
                  <td colspan="5">
                    <h1>Форма 2</h1>
                  </td>
                </tr>

                <tr class="finance__header">
                  <th
                    v-for="(title, idx) in headers"
                    :key="'one_' + idx"
                    :class="'text-' + title.align"
                  >
                    {{ title.name }}
                  </th>
                </tr>

                <tr
                  v-for="(item, idx) in financeData.formTwo"
                  :key="'formTwo' + idx"
                  class="finance__row finance__row--form-two"
                >
                  <template v-if="item.id == 2100">
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2100Value1 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2100Value2 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2100Value3 }}</strong>
                    </td>
                  </template>

                  <template v-else-if="item.id == 2200">
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2200Value1 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2200Value2 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2200Value3 }}</strong>
                    </td>
                  </template>

                  <template v-else-if="item.id == 2300">
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2300Value1 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2300Value2 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2300Value3 }}</strong>
                    </td>
                  </template>

                  <template v-else-if="item.id == 2400">
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2400Value1 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2400Value2 }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ formTwo2400Value3 }}</strong>
                    </td>
                  </template>

                  <template
                    v-else-if="
                      item.id == 2120 ||
                      item.id == 2210 ||
                      item.id == 2220 ||
                      item.id == 2330 ||
                      item.id == 2350 ||
                      item.id == 2410
                    "
                  >
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value1"
                        type="number"
                        placeholder="0"
                        prefix="–"
                        v-on:blur="
                          item.value1 =
                            Number(item.value1) < 0
                              ? Number(item.value1) * -1
                              : Number(item.value1)
                        "
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value2"
                        type="number"
                        placeholder="0"
                        prefix="–"
                        v-on:blur="item.value2 = Number(item.value2)"
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value3"
                        type="number"
                        placeholder="0"
                        prefix="–"
                        v-on:blur="item.value3 = Number(item.value3)"
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                  </template>

                  <template v-else>
                    <td>{{ getFinanceNames(item.id) }}</td>
                    <td class="text-center">
                      <em>{{ item.id }}</em>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value1"
                        type="number"
                        placeholder="0"
                        v-on:blur="item.value1 = Number(item.value1)"
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value2"
                        type="number"
                        placeholder="0"
                        v-on:blur="item.value2 = Number(item.value2)"
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.value3"
                        type="number"
                        placeholder="0"
                        v-on:blur="item.value3 = Number(item.value3)"
                        :disabled="packageMode && !editMode"
                      ></v-text-field>
                    </td>
                  </template>
                </tr>
              </table>
            </v-flex>
          </v-layout>

          <!-- <v-layout form__row form__errors row wrap v-if="errors">
                        <v-flex xs12>
                            Проверьте ошибки:
                            <strong
                                v-for="(errorForm, idx) in errors"
                                :key="`error_f${idx}`"
                            >
                                <div
                                    v-for="(error, idx) in errorForm"
                                    :key="`error_${idx}`"
                                >{{ error }}</div>
                            </strong>
                        </v-flex>
                    </v-layout>-->

          <v-layout form__row form__errors row wrap v-if="errors">
            <v-flex xs12>
              Проверьте ошибки:
              <strong v-for="(error, idx) in errors" :key="`error_f${idx}`">
                <div>{{ error }}</div>
              </strong>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="!packageMode && isPublicHashSave">
            <v-flex xs12>
              <v-btn
                @click="validate"
                color="primary"
                :disabled="isUpdated || saveLoading"
                class="mt-4 ml-0"
                :loading="saveLoading"
                id="financeSaveButton"
                >{{
                  isUpdated
                    ? "Финансовые показатели обновлены"
                    : "Сохранить финансовые показатели"
                }}</v-btn
              >
            </v-flex>
          </v-layout>

          <!-- show in Leasing and other bids package now mode -->
          <v-layout form__row row wrap v-if="packageMode && isPublicHashSave && saveCallbackName">
            <v-flex xs12>
              <v-btn
                @click="saveBidBlock"
                color="primary"
                class="mt-4 ml-0"
                id="financeSaveButtonBeforeVerificator"
                >Сохранить финансовые показатели</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <v-flex xs12 sm12 md3 v-if="!packageMode || editMode">
        <v-layout
          row
          wrap
          finance__totals
          :class="{ 'finance__totals--static': packageMode }"
        >
          <v-flex xs12 pl-0>
            <h3>Баланс активов</h3>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[2].name }}</v-flex>
              <v-flex grow text-right py-0>
                <strong
                  >{{
                    (getTotalFormOneActiveOutOfStockValue1 +
                      getTotalFormOneActiveInStockValue1)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[3].name }}</v-flex>
              <v-flex grow text-right py-0>
                <strong
                  >{{
                    (getTotalFormOneActiveOutOfStockValue2 +
                      getTotalFormOneActiveInStockValue2)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[4].name }}</v-flex>
              <v-flex grow text-right py-0>
                <strong
                  >{{
                    (getTotalFormOneActiveOutOfStockValue3 +
                      getTotalFormOneActiveInStockValue3)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>

            <v-flex xs12 pl-0>
              <h3>Баланс пассивов</h3>
            </v-flex>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[2].name }}</v-flex>
              <v-flex grow text-right py-0>
                <strong
                  >{{
                    (getTotalFormOnePassiveCapitalValue1 +
                      getTotalFormOnePassiveLongNeedsValue1 +
                      getTotalFormOnePassiveShortNeedsValue1)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[3].name }}</v-flex>
              <v-flex grow text-right py-0>
                <strong
                  >{{
                    (getTotalFormOnePassiveCapitalValue2 +
                      getTotalFormOnePassiveLongNeedsValue2 +
                      getTotalFormOnePassiveShortNeedsValue2)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex shrink py-0>{{ this.headers[4].name }}</v-flex>
              <v-flex grow text-right pt-0>
                <strong
                  >{{
                    (getTotalFormOnePassiveCapitalValue3 +
                      getTotalFormOnePassiveLongNeedsValue3 +
                      getTotalFormOnePassiveShortNeedsValue3)
                      | formatNumber
                  }}&nbsp;&#8381;</strong
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import getFinanceName from "@/utils/data/finance";
import formatNumber from "@/mixins/filters/formatNumber";
import formatPrice from "@/mixins/filters/formatPrice";
import showNotify from "@/services/noty";

// const onlyNumbers = "/^d+$/";

export default {
  name: "ClientFinance",
  mixins: [formatNumber, formatPrice],
  data: () => ({
    valid: false,
    errors: null,
    isUpdated: false,
    resp: [],
    isDownloadZip: false,
    zipErrors: null,
    headers: [
      { name: "", align: "left" },
      { name: "Код", align: "center" },
      { name: "", align: "right" },
      { name: "", align: "right" },
      { name: "", align: "right" },
    ],
    saveLoading: false,
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    financeData: {
      type: Object,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    packageId: {
      type: Number,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
    publicMode: {
      type: String,
      default: null,
    },
    bidStatus: {
      type: Number,
      default: 0,
    },
    saveCallbackName: {
      type: String,
      default: "",
    }
  },

  methods: {
    saveBidBlock() {
        this.$emit("saveBidBlock", this.saveCallbackName);
    },

    setDates() {
      const initDates = ["err 30.09.2019", "err 31.12.2018", "err 30.09.2018"];
      let dates = this.financeData.dateList
        ? this.financeData.dateList
        : initDates;
      let headersKey = 2;

      dates.map((date) => {
        this.headers[headersKey].name = date;
        headersKey++;
      });
    },
    getFinanceNames(id) {
      return getFinanceName(id);
    },
    getTotals(form, value) {
      let total = 0;
      form.map((item) => {
        total += Number(item[value]);
      });
      return total;
    },
    getFormTwoTotal(id, value) {
      const fields = {
        2100: [2110, 2120],
        2200: [2210, 2220],
        2300: [2310, 2320, 2330, 2340, 2350],
        2400: [2410, 2421, 2430, 2450, 2460],
      };
      const values = fields[id];
      let total = 0;

      this.financeData.formTwo.map((item) => {
        if (values.indexOf(item.id) + 1) {
          if (
            item.id === 2120 ||
            item.id === 2210 ||
            item.id === 2220 ||
            item.id === 2330 ||
            item.id === 2350 ||
            item.id === 2410
          ) {
            total -= Number(item[value]);
          } else {
            total += Number(item[value]);
          }
        }
      });

      return total;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.saveFinances();
      } else {
        this.$root.$emit("onNextFinance");
      }
    },
    async saveFinances() {
      this.errors = null;
      const data = this.financeData;
      const method = "POST";
      let url = "";
      if (this.publicMode) {
        url = this.publicHash
          ? `v1/financials/save-by-hash/${this.publicHash}`
          : `v1/financials/public-hash/${this.publicMode}`;
      } else {
        url = `v1/financials/${this.userId}`;
      }
      const inn = this.agentMode ? this.agentMode : "";
      const params = inn ? { inn } : {};
      this.saveLoading = true;

      await apiCallTrue({
        url,
        data,
        method,
        params,
      })
        .then(() => {
          showNotify("financials-updated");
          this.isUpdated = true;
          setTimeout(() => (this.isUpdated = false), 2000);
          this.$root.$emit("onNextFinance", true);
        })
        .catch((error) => {
          showNotify("error", error);
          this.errors = error.validation;
          this.$root.$emit("onNextFinance");
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    async downloadZip() {
      this.isDownloadZip = true;
      const inn = this.agentMode ? this.agentMode : false;
      const params = inn ? { inn } : {};

      const url =
        this.packageMode && this.packageId
          ? `v1/package/${this.packageId}/financial-compress`
          : `v1/financials/${this.userId}/compress`;

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.isDownloadZip = false;

          const link = document.createElement("a");
          link.href = response.data.data;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => (this.zipErrors = error.message));
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
    }),
    isPublicHashSave() {
      if (this.publicHash) {
        if (this.bidStatus == 0) return true;
        if (this.bidStatus == 30) return true;
        return false;
      }
      return true;
    },
    getTotalFormOneActiveOutOfStockValue1() {
      return this.getTotals(
        this.financeData.formOne.active.outOfStock,
        "value1"
      );
    },
    getTotalFormOneActiveOutOfStockValue2() {
      return this.getTotals(
        this.financeData.formOne.active.outOfStock,
        "value2"
      );
    },
    getTotalFormOneActiveOutOfStockValue3() {
      return this.getTotals(
        this.financeData.formOne.active.outOfStock,
        "value3"
      );
    },
    getTotalFormOneActiveInStockValue1() {
      return this.getTotals(this.financeData.formOne.active.inStock, "value1");
    },
    getTotalFormOneActiveInStockValue2() {
      return this.getTotals(this.financeData.formOne.active.inStock, "value2");
    },
    getTotalFormOneActiveInStockValue3() {
      return this.getTotals(this.financeData.formOne.active.inStock, "value3");
    },
    getTotalFormOnePassiveCapitalValue1() {
      return this.getTotals(this.financeData.formOne.passive.capital, "value1");
    },
    getTotalFormOnePassiveCapitalValue2() {
      return this.getTotals(this.financeData.formOne.passive.capital, "value2");
    },
    getTotalFormOnePassiveCapitalValue3() {
      return this.getTotals(this.financeData.formOne.passive.capital, "value3");
    },
    getTotalFormOnePassiveLongNeedsValue1() {
      return this.getTotals(
        this.financeData.formOne.passive.longNeeds,
        "value1"
      );
    },
    getTotalFormOnePassiveLongNeedsValue2() {
      return this.getTotals(
        this.financeData.formOne.passive.longNeeds,
        "value2"
      );
    },
    getTotalFormOnePassiveLongNeedsValue3() {
      return this.getTotals(
        this.financeData.formOne.passive.longNeeds,
        "value3"
      );
    },
    getTotalFormOnePassiveShortNeedsValue1() {
      return this.getTotals(
        this.financeData.formOne.passive.shortNeeds,
        "value1"
      );
    },
    getTotalFormOnePassiveShortNeedsValue2() {
      return this.getTotals(
        this.financeData.formOne.passive.shortNeeds,
        "value2"
      );
    },
    getTotalFormOnePassiveShortNeedsValue3() {
      return this.getTotals(
        this.financeData.formOne.passive.shortNeeds,
        "value3"
      );
    },
    formTwo2100Value1() {
      return this.getFormTwoTotal(2100, "value1");
    },
    formTwo2100Value2() {
      return this.getFormTwoTotal(2100, "value2");
    },
    formTwo2100Value3() {
      return this.getFormTwoTotal(2100, "value3");
    },
    formTwo2200Value1() {
      return this.getFormTwoTotal(2200, "value1") + this.formTwo2100Value1;
    },
    formTwo2200Value2() {
      return this.getFormTwoTotal(2200, "value2") + this.formTwo2100Value2;
    },
    formTwo2200Value3() {
      return this.getFormTwoTotal(2200, "value3") + this.formTwo2100Value3;
    },
    formTwo2300Value1() {
      return this.getFormTwoTotal(2300, "value1") + this.formTwo2200Value1;
    },
    formTwo2300Value2() {
      return this.getFormTwoTotal(2300, "value2") + this.formTwo2200Value2;
    },
    formTwo2300Value3() {
      return this.getFormTwoTotal(2300, "value3") + this.formTwo2200Value3;
    },
    formTwo2400Value1() {
      return this.getFormTwoTotal(2400, "value1") + this.formTwo2300Value1;
    },
    formTwo2400Value2() {
      return this.getFormTwoTotal(2400, "value2") + this.formTwo2300Value2;
    },
    formTwo2400Value3() {
      return this.getFormTwoTotal(2400, "value3") + this.formTwo2300Value3;
    },
  },
  mounted() {
    if (this.financeData) {
      this.setDates();
    }
  },
};
</script>
<style lang="scss">
.finance {
  text-align: left;

  &__row {
    background: #fff;
    transition: background 0.4s ease;

    &:hover {
      background: #eee;
    }

    .v-input {
      padding-top: 0;
      margin: 0 0 -12px;
      text-align: right;

      .v-input__slot {
        margin: 0;

        &::before {
          opacity: 0.2;
        }

        input {
          text-align: right;
        }
      }
    }

    &--form-two {
      strong {
        display: inline-block;
        vertical-align: top;
        padding: 8px 0;
        font-size: 16px;
      }
    }
  }

  &__table {
    td {
      padding: 4px 8px 2px;
    }
  }
  &__total {
    font-weight: 700;
  }

  &__divider {
    background: #fafafa;
    height: 24px;
  }

  &__totals {
    background: #000;
    position: fixed;
    top: 195px;
    right: 48px;
    width: 18%;
    padding: 8px;
    color: #fff;
    opacity: 0.3;
    transition: opacity 0.4s ease;

    &:hover {
      opacity: 1;
    }

    &--static {
      position: static;
      width: 100%;
      margin-top: 50px !important;
    }
  }
}
</style>
